import React from 'react';
import PropTypes from 'prop-types';
import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';

import styles from './styles.scss';

export default function ImageWithCaption({ src, caption }) {
  return (
    <PageContainer fullWidth="mobile-only">
      <Spacer
        spacing={{
          mobile: 'large 0',
          tablet: 'x-large 0',
        }}
      >
        <figure className={styles.imageWrapper}>
          <img src={src} alt={caption} className={styles.image} />
          <figcaption className={styles.caption}>{caption}</figcaption>
        </figure>
      </Spacer>
    </PageContainer>
  );
}

ImageWithCaption.propTypes = {
  src: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
};
